export class IllegalArgumentsError implements Error {
  public readonly name = "IllegalArgumentsError";
  public readonly message: string = "";

  constructor(message?: string) {
    if (message) {
      this.message = message;
    }
  }

  public toString() {
    return `${this.name}: ${this.message}`;
  }
}
